import React, { useContext, useMemo } from 'react';
import { Box, Typography, styled } from '@mui/material';

import { useWallet } from 'context/WalletContext';
import { DashboardContext } from 'context/DashboardContext';
import { getLevelByXP } from 'constants/bonusS2';
import { StandardButton } from 'components/Button';
import { TwitterIcon } from 'components/ImageComponent';
import { PromotionCard, Container } from 'components/PromotionCard';
import { ActivatedButton } from 'components/StyledComponents';

const CustomFlex = styled(Box)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

/********************  Main Component  ********************/
const TweetToEarnCard = () => {
  const { isAuthenticated } = useWallet();
  const { state } = useContext(DashboardContext);

  // Use totalPoints (boosted XP) instead of basePoints for level calculation
  const totalPoints = state.data?.totalPoints ?? 0;

  const levelInfo = useMemo(() => {
    const levelData = getLevelByXP(totalPoints);
    return {
      level: levelData.level,
      boost: levelData.boost,
    };
  }, [totalPoints]);

  return (
    <PromotionCard
      Icon={TwitterIcon}
      title="Tweet to Earn Bonus"
      tooltip="Level up bonus automatically applied based on your current XP level in Tweet to Earn"
      completed={true} // Always completed as it's automatically applied
    >
      <Container>
        <Box>
          <CustomFlex>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                padding: '8px 16px',
                backgroundColor: 'rgba(0, 255, 157, 0.1)',
                borderRadius: '20px',
                border: '1px solid rgba(0, 255, 157, 0.3)',
              }}
            >
              <Typography fontSize={12} fontWeight={500} color="text.secondary">
                LEVEL
              </Typography>
              <Typography fontSize={18} fontWeight={700} color="#00ff9d" sx={{ marginBottom: 0.2 }}>
                {levelInfo.level}
              </Typography>
            </Box>
          </CustomFlex>
        </Box>
        {!isAuthenticated && <StandardButton fullWidth>Connect to Metamask!</StandardButton>}
        {isAuthenticated && <ActivatedButton>{levelInfo.boost}% BONUS Activated</ActivatedButton>}
      </Container>
    </PromotionCard>
  );
};

export default TweetToEarnCard;
